import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaGraduationCap } from 'react-icons/fa';
import UniversityFooter from '../../components/UniversityFooter/UniversityFooter';
import './UniversityLegal.css';

const UniversityTerms = () => {
  const navigate = useNavigate();

  return (
    <div className="uni-legal-page">
      <header className="uni-legal-header">
        <button className="uni-legal-back" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back
        </button>
        <div className="uni-legal-header-brand">
          <FaGraduationCap /> ULSAAPP University
        </div>
      </header>

      <main className="uni-legal-main">
        <h1>Terms & Conditions</h1>
        <p className="uni-legal-updated">Last updated: May 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the ULSAAPP University platform, you agree to be bound by
            these Terms & Conditions. If you do not agree, please do not use the platform.
          </p>
        </section>

        <section>
          <h2>2. About the Platform</h2>
          <p>
            ULSAAPP University is a Virtual University system focused on evaluation and
            certification rather than traditional academic structures. There are no regular
            classes, fixed batches, or rigid syllabi. Students have the flexibility to choose
            their own combination of subjects.
          </p>
        </section>

        <section>
          <h2>3. AI-Generated Content</h2>
          <p>
            All exam questions are generated by artificial intelligence based on the subject
            and level you select. All answer evaluations are performed by AI after submission.
            There is no manual interference in question creation or grading. While we strive
            for accuracy, AI-generated content may occasionally contain errors.
          </p>
        </section>

        <section>
          <h2>4. User Accounts</h2>
          <ul>
            <li>You must provide accurate information during registration.</li>
            <li>You are responsible for maintaining the confidentiality of your account.</li>
            <li>You must not share your account credentials with others.</li>
            <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
          </ul>
        </section>

        <section>
          <h2>5. Exam Conduct</h2>
          <ul>
            <li>You must complete exams independently without external assistance or unfair means.</li>
            <li>Tab switching and focus loss may be monitored during exams.</li>
            <li>Submitting exams is final — answers cannot be changed after submission.</li>
            <li>The platform auto-saves your progress, but you should not close the browser during an active exam.</li>
          </ul>
        </section>

        <section>
          <h2>6. Certificates</h2>
          <p>
            Certificates are issued when you meet the minimum passing criteria (45% or above)
            on an eligible exam. Certificates are generated digitally and can be viewed on
            the platform. ULSAAPP University certificates represent performance on AI-evaluated
            exams and are not equivalent to government-recognized academic degrees.
          </p>
        </section>

        <section>
          <h2>7. Intellectual Property</h2>
          <p>
            All platform content, design, AI-generated questions, branding, and software are
            the intellectual property of ULSAAPP / AtoZas India. You may not reproduce,
            distribute, or commercially exploit any content without written permission.
          </p>
        </section>

        <section>
          <h2>8. Limitation of Liability</h2>
          <p>
            ULSAAPP University is provided "as is" without warranties of any kind. We are not
            liable for any indirect, incidental, or consequential damages arising from your
            use of the platform, including but not limited to AI evaluation inaccuracies,
            data loss, or service interruptions.
          </p>
        </section>

        <section>
          <h2>9. Modifications</h2>
          <p>
            We reserve the right to modify these Terms & Conditions at any time. Changes will
            be posted on this page. Continued use of the platform after modifications
            constitutes acceptance of the updated terms.
          </p>
        </section>

        <section>
          <h2>10. Governing Law</h2>
          <p>
            These terms are governed by the laws of India. Any disputes will be subject to
            the exclusive jurisdiction of the courts in India.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>
            For questions regarding these Terms & Conditions, contact us at{' '}
            <a href="mailto:support.ulsaapp@atozasindia.in">support.ulsaapp@atozasindia.in</a>.
          </p>
        </section>
      </main>

      <UniversityFooter />
    </div>
  );
};

export default UniversityTerms;
